import React, { Component, PureComponent } from "react";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading.js";

class RenderMetric extends PureComponent {
  render() {
    const { data, type, label, size, format } = this.props;
    return (
      <div className="col-6 col-lg-3 mb-2">
        <Heading size={6} className={"mb-2"}>
          {label}
        </Heading>
        <Metric {...data} size={size} type={type} format={format} />
      </div>
    );
  }
}

class BillingSummary extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderMetrics = (data, cells) => {
    const widgetConfig = {
      total_total_subs: {
        label: "YTD Subscribers",
      },
      monthly_total_subs: { label: "Monthly Subs" },
      annual_total_subs: { label: "Annual Subs" },
      web_total_subs: { label: "Total Web Subs" },
      in_app_purchase_total_subs: { label: "Total In App Subs" },
      ytd_entitlements: { label: "YTD DTC Entitlements" },
    };

    return cells.map((metric, key) => {
      const metric_data = data[metric];
      if (!metric_data) {
        return null;
      }
      const label = widgetConfig[metric]?.label || metric;
      const type = widgetConfig[metric]?.type || "number";
      const format = widgetConfig[metric]?.format;
      const size = ["monthly_total_subs", "annual_total_subs"].includes(metric)
        ? "sm"
        : key <= 3
        ? "lg"
        : "md";
      return (
        <RenderMetric
          data={metric_data}
          type={type}
          label={label}
          size={size}
          format={format}
          key={key}
        />
      );
    });
  };

  render() {
    const { data, cells } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row mb-3 mb-md-0 mt-4 mt-md-0">
        {this.renderMetrics(data.data, cells)}
      </div>
    );
  }
}

export default BillingSummary;
